import { useState, useEffect } from 'react';

const useWindowVisible = () => {
  const [isWindowVisible, setIsWindowVisible] = useState(false);

  useEffect(() => {
    const onVisibilityChange = () => {
      setIsWindowVisible(document.visibilityState === 'visible');
    };

    document.addEventListener('visibilitychange', onVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, []);

  return isWindowVisible;
};

export default useWindowVisible;